
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { tokenIsExpired } from "../../authUtils";
import { Assessment, Receipt, Inventory, Settings } from "@mui/icons-material";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import Diversity1Icon from '@mui/icons-material/Diversity1';
import { Card, CardContent, Button, Grid, Typography, Avatar, Box, IconButton } from "@mui/material";
import { fetchData, updateData, postData, deleteData } from '../../apiService';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import ArticleIcon from '@mui/icons-material/Article';
import NoteIcon from '@mui/icons-material/Note';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BalanceIcon from '@mui/icons-material/Balance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CategorySalesChart from './CategorySalesChart';
import SalesPaymentStatusChart from "./piechart";
// import { addMonths, subMonths, format, startOfMonth, endOfMonth, startOfWeek, endOfWeek, eachDayOfInterval, isSameMonth, isToday } from "date-fns";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Modal,
    TextField,
    Select,
} from "@mui/material";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

function Home() {
    const { isAuthenticated, companyId, username, userId, logout, token, permissions, roleName } = useAuth();
    const [showReports, setShowReports] = useState(false);
    const [favorites, setFavorites] = useState([]);
    const { id } = useParams();
    const [dataItem, setDataItem] = useState([]);
    const [toDate, setToDate] = useState('');

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    // Similar function for toDate
    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setToDate(getFormattedCurrentDate());
        fetchtableData();
        fetchTableData();
    }, [isAuthenticated, token, logout]);

    const hasReadMasterPermission = permissions.includes('Read Master');
    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasReadTransactionPermission = permissions.includes('Read Transaction');
    const hasCreateAccountsPermission = permissions.includes('Create Accounts');
    const hasReadAccountsPermission = permissions.includes('Read Accounts');
    const hasReadAdministrationPermission = permissions.includes('Read Administration');
    const hasReadReadReportsPermission = permissions.includes('Read Reports');

    const features = [
        { title: "Sales", icon: <Receipt style={{ color: '#9EBC8A', fontSize: '19px' }} />, link: "/SaleCreate" },
        { title: "Purchase", icon: <Inventory style={{ color: '#A6CDC6', fontSize: '19px' }} />, link: "/PurchaseCreate" },
        { title: "Purchase Payment", icon: <PaymentIcon style={{ color: '#A0937D', fontSize: '19px' }} />, link: "/PaymentCreate" },
        { title: "Sale Receipt", icon: <ReceiptLongIcon style={{ color: '#80B9AD', fontSize: '19px' }} />, link: "/ReceiptCreate" },
        { title: "Payment & Receipt", icon: <NoteIcon style={{ color: '#80B9AD' }} />, link: "/PaymentAndReceiptCreate" },

    ];


    // Grouped report data
    const groupedReports = {
        Accounts: [
            { id: 1, name: "CashBook", icon: <CurrencyRupeeIcon style={{ color: '#C39898', fontSize: '19px' }} />, link: "/CashBook" },
            { id: 2, name: "Ledger", icon: <SummarizeIcon style={{ color: '#A27B5C', fontSize: '19px' }} />, link: "/Ledger" },
            { id: 3, name: "Creditor Debitor", icon: <SummarizeIcon style={{ color: '#123524', fontSize: '19px' }} />, link: "/CreditorDebitorReport" },
            { id: 4, name: "Customer Outstanding", icon: <PermIdentityIcon style={{ color: '#2C3930', fontSize: '19px' }} />, link: "/CustomerOutstandingReport" },
            { id: 5, name: "Supllier Outstanding", icon: <SupervisedUserCircleIcon style={{ color: '#6D2323', fontSize: '19px' }} />, link: "/SupplierOutstandingReport" },
            { id: 6, name: "Daily Sale Profit", icon: <AttachMoneyIcon style={{ color: '#987D9A', fontSize: '19px' }} />, link: "/DailySaleProfitReport" },
            { id: 7, name: "Trial Balance", icon: <BalanceIcon style={{ color: '#80B9AD', fontSize: '19px' }} />, link: "/TrialBalanceReport" },
        ],
        Sales: [
            { id: 8, name: "Sale Register", icon: <ArticleIcon style={{ color: '#9AA6B2', fontSize: '19px' }} />, link: "/SaleRegister" },
            { id: 9, name: "Sale Report", icon: <BalanceIcon style={{ color: '#80B9AD', fontSize: '19px' }} />, link: "/PartyandItemWiseReport" },
            { id: 10, name: "Sale Gst", icon: <TextSnippetIcon style={{ color: '#1A4870', fontSize: '19px' }} />, link: "/SaleGstReport" },
            { id: 11, name: "Sale HSNC", icon: <ArticleIcon style={{ color: '#213555', fontSize: '19px' }} />, link: "/SaleHSNCReport" },
            { id: 12, name: "Sale Analysis", icon: <ShowChartIcon style={{ color: '#987D9A', fontSize: '19px' }} />, link: "/SaleAnalysisReport" },
            { id: 13, name: "Daily Settlement", icon: <PaymentIcon style={{ color: '#6B4226', fontSize: '19px' }} />, link: "/SalePaymentWise" },
            { id: 14, name: "Stock", icon: <ShowChartIcon style={{ color: '#987D9A', fontSize: '19px' }} />, link: "/Stock" },
            
        ],
        Purchase: [
            { id: 15, name: "Purchase Register", icon: <NoteIcon style={{ color: '#86A788', fontSize: '19px' }} />, link: "/PurchaseRegisterReport" },
            { id: 16, name: "Purchase Report", icon: <BalanceIcon style={{ color: '#80B9AD', fontSize: '19px' }} />, link: "/PurchasePartyandItemWiseReport" },
        ]
    };

    const [activeGroup, setActiveGroup] = useState(null); // null or group name

    const toggleGroup = (group) => {
        setActiveGroup(activeGroup === group ? null : group);
    };

    const groupColors = {
        Accounts: { main: "rgba(156,39,176,0.15)", hover: "rgba(156,39,176,0.25)" },
        Sales: { main: "rgba(76,175,80,0.15)", hover: "rgba(76,175,80,0.25)" },
        Purchase: { main: "rgba(255,165,0,0.15)", hover: "rgba(255,165,0,0.25)" },
    };

    const toggleFavorite = async (report) => {
        try {
            const existingItems = await fetchData('PinnedItemsApi', `/${companyId}/${userId}`, token);

            if (
                existingItems.response_data?.some(
                    (item) => item.ReportDescription === report.name
                )
            ) {
                alert('This report is already in your favorites.');
                return;
            }

            const pinned = {
                ReportDescription: report.name,
                ReportId: report.id,
                IsLocked: true,
                CompanyId: companyId,
                UserId: userId,
            };

            const response = await postData('PinnedItemsApi', pinned, token);
            fetchtableData(); // Refresh the pinned items
            alert('Favorite added successfully!');
            if (response.status === 200) {
                const updatedFavorites = favorites.includes(report.id)
                    ? favorites.filter((favId) => favId !== report.id)
                    : [...favorites, report.id];
                setFavorites(updatedFavorites);

            } else {
                console.error('Error adding favorite:', response.data?.message || 'Unknown error');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    };

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const fetchtableData = async () => {
        fetchData('PinnedItemsApi', `/${companyId}/${userId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Supplier Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleFavoriteRemove = async (id) => {
        try {
            await deleteData('PinnedItemsApi', `${id}`, token); // Perform the delete operation
            fetchtableData(); // Refresh the table data
        } catch (error) {
            console.error('Error deleting record:', error);
        }
    };



    const [currentMonth, setCurrentMonth] = useState(new Date());

    // Helper functions
    const prevMonth = () => {
        const prev = new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1);
        setCurrentMonth(prev);
    };

    const nextMonth = () => {
        const next = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1);
        setCurrentMonth(next);
    };

    const getDaysInMonth = (month, year) => {
        const date = new Date(year, month, 1);
        const days = [];
        const firstDay = new Date(year, month, 1).getDay(); // Day of week (0-6)
        const lastDate = new Date(year, month + 1, 0).getDate(); // Last date of month

        // Add blank days for first week
        for (let i = 0; i < firstDay; i++) {
            days.push(null);
        }

        // Add all dates of the month
        for (let d = 1; d <= lastDate; d++) {
            days.push(new Date(year, month, d));
        }

        return days;
    };

    const days = getDaysInMonth(currentMonth.getMonth(), currentMonth.getFullYear());

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const [selectedDate, setSelectedDate] = React.useState(null); // store the selected date

    // Update your dayStyle function
    const dayStyle = (day) => {
        const isToday = day && day.toDateString() === new Date().toDateString();
        const isSelected = day && selectedDate && day.toDateString() === selectedDate.toDateString();

        return {
            width: "30px",
            height: "30px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "2px",
            borderRadius: "4px",
            backgroundColor: isSelected
                ? "yellow" // highlight selected date
                : isToday
                    ? "#1A1A1D" // today
                    : day
                        ? "#f0f0f0" // normal day
                        : "transparent", // empty cell
            color: isSelected
                ? "#1A1A1D"
                : isToday
                    ? "#fff"
                    : "#1A1A1D",
            fontSize: "12px",
            cursor: day ? "pointer" : "default",
        };
    };

    // Selected Day Datalog
    const [open, setOpen] = useState(false);
    // Inside your component, after fetching data
    const [dailyStatement, setDailyStatement] = useState(null);

    // When fetching
    const handleDateClick = async (day) => {
        setSelectedDate(day);
        setOpen(true);
        // ✅ Format as local date (no UTC conversion)
        const formattedDate = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
        try {
            setDataItem([]); // optional, if you have a table
            const response = await fetchData(
                'ReportApi',
                `/DailyStatement/${formattedDate}/${formattedDate}/${companyId}`,
                token
            );

            if (response.responseCode === '1111') {
                const ds = response.response_data; // assuming API returns object like DailyStatement
                setDailyStatement(ds);
            }
        } catch (error) {
            console.error('Error fetching Daily Statement Details:', error);
        }
    };

    // Group your metrics
    const quantityMetrics = dailyStatement
        ? [
            { label: "Sale", value: dailyStatement.SaleQuantity },
            { label: "Purchase", value: dailyStatement.PurchaseQuantity },
        ]
        : [];

    const salesMetrics = dailyStatement
        ? [
            { label: "Cash", value: dailyStatement.SaleCashAmount },
            { label: "Card", value: dailyStatement.SaleCardAmount },
            { label: "UPI", value: dailyStatement.SaleUpiAmount },
            { label: "Credit", value: dailyStatement.SaleCreditAmount },
        ]
        : [];

    const purchaseMetrics = dailyStatement
        ? [
            { label: "Cash", value: dailyStatement.PurchaseCashAmount },
            { label: "Credit", value: dailyStatement.PurchaseCreditAmount },
        ]
        : [];

    const receiptsMetrics = dailyStatement
        ? [
            { label: "Payment", value: dailyStatement.PaymentAmount },
            { label: "Receipt", value: dailyStatement.ReceiptAmount },
            { label: "Income", value: dailyStatement.IncomeAmount },
            { label: "Expense", value: dailyStatement.ExpenseAmount },
        ]
        : [];

    const fetchTableData = async (date) => {
        if (!date) return;
        setDataItem([]);
        try {
            const formattedDate = date.toISOString().split('T')[0]; // YYYY-MM-DD
            const response = await fetchData(
                'ReportApi',
                `/DailyStatement/${formattedDate}/${formattedDate}/${companyId}`,
                token
            );

            if (response.responseCode === '1111') {
                setDataItem(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Daily Statement Details:', error);
        }
    };


    return (
        <div className="p-4" style={{ width: "100%" }}>
            <Grid container spacing={2}>

                {/* Left side - Features stacked */}
                <Grid item xs={12} md={2}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        <Card
                            style={{
                                padding: "7px",
                                borderRadius: "12px",
                                //backgroundColor: "#1E1E1E",
                                backgroundColor: "#0D1B2A",
                                color: "#F5F5F5",
                                maxWidth: "250px",
                                margin: "auto",
                                boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                            }}
                        >
                            <CardContent>
                                {/* Header with month navigation */}
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                    <IconButton size="small" onClick={prevMonth} style={{ color: "#F5F5F5" }}>
                                        <ArrowBackIosIcon fontSize="small" />
                                    </IconButton>
                                    <Typography variant="subtitle1" style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                                        {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
                                    </Typography>
                                    <IconButton size="small" onClick={nextMonth} style={{ color: "#F5F5F5" }}>
                                        <ArrowForwardIosIcon fontSize="small" />
                                    </IconButton>
                                </div>

                                {/* Days of the week */}
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(7, 1fr)",
                                    gap: "3px",
                                    textAlign: "center",
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                    color: "#A0C1E8"
                                }}>
                                    {["S", "M", "T", "W", "T", "F", "S"].map((d) => (
                                        <div key={d}>{d}</div>
                                    ))}
                                </div>

                                {/* Calendar days */}
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(7, 1fr)",
                                    gap: "6px",
                                    justifyItems: "center",
                                }}>
                                    {/* {days.map((day, index) => {
                                        if (!day) return <div key={index} />;

                                        const isToday = day.toDateString() === new Date().toDateString();
                                        const isSelected = selectedDate && day.toDateString() === selectedDate.toDateString();

                                        return (
                                            <div
                                                key={index}
                                                onClick={() => { setSelectedDate(day); setOpen(true); }}
                                                style={{
                                                    width: "25px",
                                                    height: "28px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "8px",
                                                    fontSize: "11.5px",
                                                    backgroundColor: isSelected ? "#FFD166" : isToday ? "#EF476F" : "#102A43",
                                                    color: isSelected ? "#1A1A1D" : isToday ? "#FFF" : "#E0E6ED",
                                                    fontWeight: isToday || isSelected ? "bold" : "normal",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                onMouseEnter={(e) => { if (!isToday && !isSelected) e.currentTarget.style.backgroundColor = "#1B3B6F"; }}
                                                onMouseLeave={(e) => { if (!isToday && !isSelected) e.currentTarget.style.backgroundColor = "#102A43"; }}
                                            >
                                                {day.getDate()}
                                            </div>
                                        );
                                    })} */}
                                    {days.map((day, index) => {
                                        if (!day) return <div key={index} />;

                                        const isToday = day.toDateString() === new Date().toDateString();
                                        const isSelected = selectedDate && day.toDateString() === selectedDate.toDateString();

                                        const handleClick = () => {
                                            handleDateClick(day);
                                            fetchTableData(day); // Pass the clicked day explicitly
                                        }

                                        return (
                                            <div
                                                key={index}
                                                onClick={handleClick}
                                                style={{
                                                    width: "25px",
                                                    height: "28px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "8px",
                                                    fontSize: "11.5px",
                                                    backgroundColor: isSelected ? "#FFD166" : isToday ? "#EF476F" : "#102A43",
                                                    color: isSelected ? "#1A1A1D" : isToday ? "#FFF" : "#E0E6ED",
                                                    fontWeight: isToday || isSelected ? "bold" : "normal",
                                                    cursor: "pointer",
                                                    transition: "all 0.2s ease-in-out"
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isToday && !isSelected) e.currentTarget.style.backgroundColor = "#1B3B6F";
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!isToday && !isSelected) e.currentTarget.style.backgroundColor = "#102A43";
                                                }}
                                            >
                                                {day.getDate()}
                                            </div>
                                        );
                                    })}

                                </div>

                            </CardContent>
                        </Card>
                        {/* Feature Cards */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {features.map((feature, index) => {
                                const isAllowed =
                                    feature.title === "Payment" || feature.title === "Receipt"
                                        ? hasCreateAccountsPermission
                                        : feature.title === "Reports"
                                            ? hasReadReadReportsPermission
                                            : hasCreateTransactionPermission;

                                return (

                                    <Card
                                        key={index}
                                        className={`transition-transform duration-300 ease-in-out transform ${isAllowed ? "hover:-translate-y-1 hover:shadow-2xl" : "opacity-50 cursor-not-allowed"
                                            }`}
                                        style={{
                                            padding: "7px",
                                            borderRadius: "12px",
                                            backgroundColor: "#0D1B2A",
                                            color: "#F5F5F5",
                                            maxWidth: "250px",
                                            margin: "auto",
                                            boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                                        }}
                                    >
                                        <CardContent
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-start",
                                                height: "30px",
                                                padding: "8px 10px",
                                                gap: "4px",
                                                width: "300px",
                                            }}
                                        >
                                            <Link
                                                to={feature.link}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                    width: "100%",
                                                    fontFamily: "monospace",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "18px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: 'whitesmoke'
                                                    }}
                                                >
                                                    {feature.icon}
                                                </span>
                                                <Typography
                                                    variant="subtitle1"
                                                    style={{
                                                        marginLeft: "10px",
                                                        fontWeight: 500,
                                                        textTransform: "uppercase",
                                                        fontSize: "11px",
                                                    }}
                                                >
                                                    {feature.title}
                                                </Typography>
                                            </Link>
                                        </CardContent>
                                    </Card>

                                );
                            })}
                        </div>
                    </div>
                </Grid>

                {/* Middle - Charts */}
                <Grid item xs={12} md={7} style={{ marginTop: '-50px' }}>
                    <CategorySalesChart />
                    <SalesPaymentStatusChart />
                </Grid>

                <Grid item xs={12} md={3} style={{ marginTop: '-50px' }}>
                    <h6
                        style={{
                            fontFamily: 'Verdana, sans-serif',
                            fontSize: '14px',
                            textTransform: 'uppercase',
                            fontWeight: '900',
                            color: '#4b3f72',
                            textAlign: 'center',
                            marginBottom: '16px',
                            letterSpacing: '1px',
                            position: 'relative',
                        }}
                    >
                        REPORT LIST
                        <span
                            style={{
                                content: '""',
                                position: 'absolute',
                                bottom: '-4px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                width: '40px',
                                height: '3px',
                                background: 'linear-gradient(90deg, #6a5acd, #ff7f50)',
                                borderRadius: '2px',
                            }}
                        />
                    </h6>

                    <div className="flex flex-col gap-2">
                        {Object.keys(groupedReports).map((groupName, idx) => {
                            const colors = groupColors[groupName]; // main + hover colors for the group

                            return (
                                <div key={idx}>
                                    {/* Group Header */}
                                    <Card
                                        onClick={() => toggleGroup(groupName)}
                                        sx={{
                                            backgroundColor: activeGroup === groupName ? colors.main : "transparent",
                                            "&:hover": { backgroundColor: colors.hover },
                                            borderRadius: 2,
                                            padding: "10px 15px",
                                            cursor: "pointer",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            fontWeight: "bold",
                                            transition: "0.3s",
                                            mb: 1,
                                            textTransform: "uppercase",
                                            fontFamily: "monospace",
                                            fontSize: "14px",
                                        }}
                                    >
                                        {groupName}
                                        <span
                                            style={{
                                                transform: activeGroup === groupName ? "rotate(90deg)" : "rotate(0deg)",
                                                transition: "0.3s",
                                            }}
                                        >
                                            ▶
                                        </span>
                                    </Card>

                                    {/* Sub-reports */}
                                    {activeGroup === groupName && (
                                        <div className="flex flex-col gap-2 mt-2">
                                            {groupedReports[groupName].map((report, index) => (
                                                <Card
                                                    key={report.id}
                                                    style={{
                                                        background: colors.main, // match main group color
                                                        borderLeft: `5px solid ${colors.hover}`, // slightly darker for accent
                                                        borderRadius: "8px",
                                                        padding: "8px 12px",
                                                        transition: "all 0.3s ease",
                                                        cursor: "pointer",
                                                        display: "flex",
                                                        alignItems: "center",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.background = colors.hover; // hover effect
                                                        e.currentTarget.style.transform = "translateX(5px)";
                                                        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.background = colors.main;
                                                        e.currentTarget.style.transform = "translateX(0)";
                                                        e.currentTarget.style.boxShadow = "none";
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "36px",
                                                            height: "36px",
                                                            borderRadius: "50%",
                                                            background: "#ffffff88",
                                                            marginRight: "12px",
                                                            fontSize: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        {report.icon}
                                                    </span>
                                                    <Typography
                                                        variant="h6"
                                                        style={{
                                                            fontSize: "11px",
                                                            fontWeight: "600",
                                                            fontFamily: "monospace",
                                                            color: "#2b2b2b",
                                                            textTransform: "uppercase",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <Link
                                                            to={report.link}
                                                            style={{
                                                                textDecoration: "none",
                                                                color: "inherit",
                                                                display: "block",
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            {report.name}
                                                        </Link>
                                                    </Typography>
                                                </Card>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>


                </Grid>

            </Grid>

            {/* Modal for selected date details */}
            <Modal open={open} onClose={() => setOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "#f7f9fc",
                        p: 3,
                        borderRadius: 3,
                        minWidth: 420,
                        maxWidth: 600,
                        maxHeight: "80vh",
                        overflowY: "auto",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            mb: 1,
                            fontWeight: 'bolder',
                            textAlign: "center",
                            fontFamily: "'Times New Roman', serif",
                            color: "#020b13ff",
                            fontSize: 13,
                            textTransform: "uppercase",
                        }}
                    >
                        {selectedDate ? `Stats for ${selectedDate.toDateString()}` : "Date Stats"}
                    </Typography>

                    {[
                        { title: "Quantities", metrics: quantityMetrics, bg: "#e6f0ff" },
                        { title: "Purchases", metrics: purchaseMetrics, bg: "#fff5e6" },
                        { title: "Sales", metrics: salesMetrics, bg: "#e6ffe6" },
                        { title: "Receipts", metrics: receiptsMetrics, bg: "#fff0f5" },
                    ].map((section, idx) => (
                        <Box key={idx} sx={{ mb: 1, borderRadius: 2, overflow: "hidden" }}>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    mb: 0,
                                    p: 0.5,
                                    fontWeight: 600,
                                    backgroundColor: section.bg,
                                    color: "#1f2937",
                                    fontSize: 12,
                                    fontFamily: "'Times New Roman', serif",
                                    textTransform: "uppercase",
                                    textAlign: "center",
                                }}
                            >
                                {section.title}
                            </Typography>
                            <Paper variant="outlined" sx={{ borderRadius: 0, cursor: "pointer", }}>
                                <Table size="small">
                                    <TableBody>
                                        {section.metrics.map((m, i) => (
                                            <TableRow key={i} hover>
                                                <TableCell
                                                    sx={{
                                                        fontSize: 12,
                                                        fontWeight: 'bolder',
                                                        padding: "6px 8px",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    {m.label}
                                                </TableCell>
                                                <TableCell
                                                    sx={{
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        textAlign: "right",
                                                        padding: "6px 8px",
                                                        color: "#111827",
                                                    }}
                                                >
                                                    {m.value}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Paper>
                        </Box>
                    ))}
                </Box>
            </Modal>

        </div >
    );
}

export default Home;



